import { combineReducers, Reducer } from 'redux';

import selectedType from './workItemsSearch/listsReducer';
import criteriaByType from './workItemsSearch/criteriaReducer';
import resultsByType from './workItemsSearch/resultsReducer';

import { WaiverWorkItemsListType } from '../../../types/waiverWorkItem';
import { WaiverWorkItemSearchCriteriaState } from './workItemsSearch/criteriaReducer';
import { WaiverWorkItemSearchResultsState } from './workItemsSearch/resultsReducer';

import { Action } from '../../types';

export interface WaiverWorkItemsSearchState {
  selectedType: WaiverWorkItemsListType;
  criteriaByType: WaiverWorkItemSearchCriteriaState;
  resultsByType: WaiverWorkItemSearchResultsState;
}

const rootReducer: Reducer<WaiverWorkItemsSearchState, Action<any>> = combineReducers({
  selectedType,
  criteriaByType,
  resultsByType,
});

export default rootReducer;
